import { TabProxy } from "encampy";
import { automateEPlanLogin } from "./portalLogin/eplan";

export function getEPlanNavigateToPaymentAutomation(
  username: string,
  password: string,
  reportingYear: number,
  portalReportId?: string,
  invoiceNumber?: string
): (tab: TabProxy) => Promise<void> {
  // Validate that at least one identifier is provided
  if (!portalReportId && !invoiceNumber) {
    throw new Error("Either portalReportId or invoiceNumber must be provided");
  }

  return async (tab: TabProxy) => {
    // Login first
    await automateEPlanLogin(tab, username, password);

    // Select filing year and click continue
    await tab.waitForElement("select[name='filingYear']", { timeout: 5000 });
    await tab.select("select[name='filingYear']", reportingYear.toString());
    await tab.click('input[type="submit"][value="Continue"]');

    // Wait for navigation after submitting filing year
    await tab.waitForNavigation({ timeout: 10000 });

    // Navigate based on identifier type
    if (invoiceNumber) {
      // Direct navigation to payment page using invoice number
      const directPaymentUrl = `https://tier2.erplan.net/onlinefiling/payments/paymentprocess.htm?id=${invoiceNumber}&type=all`;
      await tab.navigate(directPaymentUrl);
    } else if (portalReportId) {
      // Navigate to invoice page and find the correct invoice
      await tab.navigate("https://tier2.erplan.net/onlinefiling/invoice.htm");

      // Wait for unpaid invoice table to load
      await tab.waitForElement("table#InvoiceNotPaid", { timeout: 10000 });

      // Click the payment button for the table containing the portal report ID
      await tab.clickContaining(
        `input[value="Pay by Credit Card"]`,
        `(FacID:${portalReportId})`,
        `table#InvoiceNotPaid`
      );
    }
  };
}
